import React from "react";
import Dialog from "components/dialog";
import { format } from "lib/globalize-util";
import Button from "components/form/button";
import { IBrandTerms } from "./hooks";
import { TermsAndConditionsEditor, Tabs } from "./terms-and-conditions-editor";
import { $, merge } from "glamor";
import theme from "styles/theme";
import moment from "moment";

interface ITermsModalProps {
    open: boolean;
    onClose: () => void;
    terms: IBrandTerms;
}

export const TermsModal: React.FunctionComponent<ITermsModalProps> = ({ open, onClose, terms }) => {
    const styles = React.useMemo(() => {
        return {
            label: {
                color: "inherit",
                lineHeight: "20px",
            },
            button: {
                marginRight: "15px",
            },
            message: {
                marginBottom: "20px",
            },
            checkbox: {
                display: "block",
            },
        };
    }, []);

    const contentStyles = React.useMemo(() => {
        return merge(
            $(" .updatedDate", {
                fontSize: "11px",
                color: theme.palette.darkGrey,
            }),
            $(" .termsPrompt", {
                fontSize: "14px",
                padding: "5px 0px",
                color: theme.palette.darkGrey,
            }),
            $(" .confirmation", {
                paddingTop: "15px",
            })
        );
    }, []);

    const handleClose = React.useCallback(() => {
        onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dialog
            onRequestClose={onClose}
            title={format("Terms & Conditions")}
            open={open}
            contentClassName={`${contentStyles}`}
            actions={[
                <Button
                    key="btn-dismiss"
                    label={format("Cancel")}
                    disabled={true}
                    onClick={handleClose}
                    style={styles.button}
                />,
                <Button key="btn-save" label={format("I Accept")} disabled={true} primary={true} />,
            ]}
        >
            <div className="updatedDate">{`${format("Updated")} ${moment(terms.modified_on)
                .local()
                .format("MMM D, YYYY")}`}</div>
            <div className="termsPrompt">
                {format("We've updated our terms and conditions. Please read and accept the following:")}
            </div>
            <TermsAndConditionsEditor preview={true} selectedTab={Tabs.Preview} value={terms?.body || ""} />
            <div className="confirmation">
                {format("By clicking I Accept, I affirm that I have read and agree to the conditions above.")}
            </div>
        </Dialog>
    );
};
